import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PageTitle from '../../../layouts/PageTitle';
import VacationBalanceSection from './VacationBalanceAdminPage';
import SemesterskuldSection from './SemesterskuldPage';

/**
 * SemesterPage — unified Lön→Semester page.
 *
 * Two scroll-anchored sections (no submenu, no tabs):
 *   #saldon — per-employee earned/carried/saved days admin (VacationBalanceSection)
 *   #skuld  — semesterskuldsberäkning och bokning på 2940 (SemesterskuldSection)
 *
 * Deep-link support: visiting `/payroll/semester#saldon` or `#skuld` scrolls
 * the page to that section on mount. The sticky mini-nav at the top also
 * scrolls between sections without touching the URL hash (smoothScroll).
 *
 * Why one page: semester admin happens in a single mental session — payroll
 * admin opens this area at year-end rollover (§7 accrual + semesterskuldsbokning),
 * not as separate tasks. Fortnox handles it the same way.
 */

const SECTIONS = [
  { id: 'saldon', label: 'Saldon', hint: 'Per-anställd tjänat/överförda/sparat' },
  { id: 'skuld',  label: 'Skuld',  hint: 'Bokning på 2940 vid bokslut' },
];

const SemesterPage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const target = document.getElementById(hash.replace('#', ''));
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [hash]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <PageTitle activeMenu="Semester" motherMenu="Lön" />

      <div
        style={{
          position: 'sticky', top: 0, zIndex: 10,
          background: '#fff', padding: '8px 0', marginBottom: 16,
          borderBottom: '1px solid #e5e7eb',
          display: 'flex', gap: 8, flexWrap: 'wrap',
        }}
      >
        {SECTIONS.map((s) => (
          <button
            key={s.id}
            type="button"
            onClick={() => scrollTo(s.id)}
            title={s.hint}
            style={{
              border: '1px solid #d1d5db', borderRadius: 6,
              background: '#f9fafb', padding: '6px 14px',
              fontSize: 13, fontWeight: 500, cursor: 'pointer',
              color: '#374151',
            }}
          >
            {s.label}
          </button>
        ))}
      </div>

      <section id="saldon" style={{ scrollMarginTop: 64, marginBottom: 48 }}>
        <h4 className="mb-3" style={{ fontWeight: 700 }}>Semestersaldon</h4>
        <VacationBalanceSection />
      </section>

      <section id="skuld" style={{ scrollMarginTop: 64, marginBottom: 48 }}>
        <h4 className="mb-3" style={{ fontWeight: 700 }}>Semesterskuld</h4>
        <SemesterskuldSection />
      </section>
    </>
  );
};

export default SemesterPage;
